import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import {
  Field, PickerInput, PickerColumn, PickerConfirmEventParams,
} from '@hb/coffee';
import _ from 'lodash';
import DictApi from '@/api/dict';
import type { AddressForm } from '@/shared/utils/areaPicker/types';
import type { SupplementInfoField } from '@/components/supplement-info-fields/types';
import {
  transformTileDataToCascade,
  transformFormDataToPicker,
  transformPickerParamsToForm,
  isEmptyAddressValue,
} from '../../utils';

@Component({ name: 'CompanyAddress' })
export default class CompanyAddress extends Vue implements SupplementInfoField {
  @Prop()
  private value!: AddressForm;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: (
    (value: AddressForm | null, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyAddress: PickerColumn | null = null;

  private errorMsg = '';

  /** 省市区选择器数据源 */
  private addressColumns: PickerColumn = [];

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  private async created() {
    if (this.value) {
      this.companyAddress = transformFormDataToPicker(this.value);
    }

    const addressList = await DictApi.getAddressList();
    this.addressColumns = transformTileDataToCascade(addressList);
  }

  @Watch('value')
  private onPropsValueChange(val: AddressForm) {
    this.companyAddress = transformFormDataToPicker(val);
  }

  public onValidator(): boolean {
    if (typeof this.validator === 'function') {
      return this.validator(
        this.value,
        this.setErrorMsg.bind(this),
      );
    }

    if (isEmptyAddressValue(this.value)) {
      this.setErrorMsg('请选择单位地址');
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeAddress(params: PickerConfirmEventParams) {
    this.errorMsg = '';

    this.$emit('change', transformPickerParamsToForm(params));
  }

  private addressFormatter(value: string) {
    if (!value) return value;

    return _.uniq(value.split(' ')).join(' ');
  }

  private render() {
    return (
      <Field
        label="单位地址"
        errorMessage={this.errorMsg}
      >
        <PickerInput
          v-model={this.companyAddress}
          title="选择省市区"
          placeholder="选择省市区"
          columns={this.addressColumns}
          formatter={this.addressFormatter}
          onChange={this.onChangeAddress}
        />
    </Field>
    );
  }
}
